// Material UI components

import Avatar from "@material-ui/core/Avatar"
import Button from "@material-ui/core/Button"
import CircularProgress from "@material-ui/core/CircularProgress"
import Container from "@material-ui/core/Container"
import CssBaseline from "@material-ui/core/CssBaseline"
import withStyles from "@material-ui/core/styles/withStyles"
import TextField from "@material-ui/core/TextField"
import Typography from "@material-ui/core/Typography"
import axios from "axios"
import React, { Component } from "react"
import { server } from "../actions/backend-url"
import logo from "../images/CXL.png"
import backButton from "../images/mock-back-button.png"

const styles = (theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  customError: {
    color: "red",
    fontSize: "0.8rem",
    marginTop: 10,
  },
  progess: {
    position: "absolute",
  },
})

class ResetPassword extends Component {
  constructor(props) {
    super(props)

    this.state = {
      email: "",
      password: "",
      errors: [],
      loading: false,
    }
  }

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  handleSubmit = (event) => {
    event.preventDefault()
    this.setState({ loading: true })
    const userData = {
      email: this.state.email,
      password: this.state.password,
    }
    axios
      .post(`${server}/resetPassword`, userData)
      .then((response) => {
        localStorage.setItem("AuthToken", `Bearer ${response.data.token}`)
        console.log(`Bearer ${response.data.token}`)
        this.setState({
          loading: false,
          success: true,
        })
      })
      .catch((error) => {
        this.setState({
          errors: error.response.data,
          loading: false,
        })
      })
  }

  render() {
    const { classes } = this.props
    const { errors, loading, success } = this.state
    return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div>
          <a href="https://mysentinel.info/login">
            <img src={backButton} alt="Missing" />
          </a>
        </div>
        <div className={classes.paper}>
          <Avatar variant="square" src={logo}>
            {/* <LockOutlinedIcon /> */}
          </Avatar>
          <Typography component="h1" variant="h5">
            Reset Password
          </Typography>
          <form className={classes.form} noValidate>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              helperText={errors.email}
              error={!!errors.email}
              onChange={this.handleChange}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={this.handleSubmit}
              disabled={loading || !this.state.email}
            >
              Reset Password
              {loading && <CircularProgress size={30} className={classes.progess} />}
            </Button>
            {errors.general && (
              <Typography variant="body2" className={classes.customError}>
                {errors.general}
              </Typography>
            )}

            {success && (
              <Typography variant="body2" color="primary">
                Password reset email send!
              </Typography>
            )}
          </form>
        </div>
      </Container>
    )
  }
}

export default withStyles(styles)(ResetPassword)
